import apiClient from "../core/HttpClient";
import { AllergyCategory } from "../models";
import { AllergyCategoryViewModel } from "../viewModels";

export default class AllergyCategoryService{
    url="/AllergyCategories";

    public async getAllergyCategories(): Promise<AllergyCategory[]> {
        return await apiClient.get(this.url).then((res) => res.data);
    }

    public async getAllergyCategory(id: string): Promise<AllergyCategoryViewModel> {
        return await apiClient.get(`${this.url}/${id}`).then((res) => res.data);
    }

    public async createAllergyCategory(allergyCategory: AllergyCategory) {
        return await apiClient.post(this.url, allergyCategory);
    }

    public async updateAllergyCategory(allergyCategory: AllergyCategory) {
        return await apiClient.put(`${this.url}/${allergyCategory.id}`, allergyCategory);
    }

    public async deleteAllergyCategory(id: number): Promise<void> {
        await apiClient.delete(`${this.url}/${id}`);
    }
    
}